import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getStockHold } from "services/data.internal.service";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import TimelineList from "ui-components/Timeline/TimelineList";

const columns = [
  { label: "Zone ID", id: "zoneID" },
  { label: "Location ID", id: "locationID" },
  { label: "SKU Code", id: "skuCode" },
  { label: "Pallet Nbr", id: "palletNbr" },
  { label: "MLN", id: "mln" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "Hold Qty", id: "holdQuantity", align: "right" },
  { label: "Unhold Qty", id: "unholdQuantity", align: "right" },
];

function StockHoldDrawer({ open, setOpen, sHoldRequest, setSHoldRequest }) {

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["stock-hold-log", { sHoldRequest }],
    queryFn: () => getStockHold(sHoldRequest),
    enabled: sHoldRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Stock Hold Number : </b>
                {item.stockHoldNo}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={6}>
                <b>Reason : </b>
                {item.reasonCode}
              </Grid>
              <Grid item xs={12}>
                <b>Remark : </b>
                {item.remark}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.stockHoldDetails} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
    },
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setSHoldRequest(null);
  };

  return (
    <Drawer width="950px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default StockHoldDrawer;
